/** Decode common HTML entities (e.g. &#8211; → en-dash) for display. */
export function decodeHtmlEntities(text) {
  if (text == null || text === '') return '';
  let s = String(text);
  s = s.replace(/&#(\d+);/g, (match, code) => {
    const n = Number(code);
    return Number.isFinite(n) ? String.fromCodePoint(n) : match;
  });
  s = s.replace(/&#x([0-9a-f]+);/gi, (match, hex) => {
    const n = parseInt(hex, 16);
    return Number.isFinite(n) ? String.fromCodePoint(n) : match;
  });
  s = s
    .replace(/&nbsp;/gi, ' ')
    .replace(/&quot;/gi, '"')
    .replace(/&apos;/gi, "'")
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&amp;/gi, '&');
  return s;
}

/**
 * Turns AI-generated answers (often one long line) into readable multi-line text.
 * Safe to run on every display and before bulk save.
 */
export function formatStructuredAnswer(text) {
  if (text == null || text === '') return '';

  let s = decodeHtmlEntities(String(text));
  s = s.replace(/\\n/g, '\n').replace(/\\t/g, '\t');
  s = s.replace(/\r\n/g, '\n');

  if (s.includes('\n\n') && (s.match(/\n/g) || []).length >= 4) {
    return collapseBlankLines(s.trim());
  }

  // Section headers like "**Core Components:**" (not "1. **Item:**")
  s = s.replace(/([^\n])\s+(\*\*[A-Za-z0-9][^*\n]{0,80}:\*\*)/g, (match, before, header, offset, whole) => {
    if (before === '*' || before === '-') return match;
    if (before === '.' && offset > 0 && /\d/.test(whole.charAt(offset - 1))) {
      return match;
    }
    return `${before}\n\n${header}`;
  });

  // Each numbered item on its own line: "1. **Title:** …"
  s = s.replace(/([^\n])\s+(?=\d+\.\s+\*\*)/g, '$1\n\n');

  // Plain numbered lists without bold titles
  s = s.replace(/([.!?])\s+(\d+\.\s+(?!\*\*))/g, '$1\n\n$2');

  // Inline steps: "1. Problem definition 2. Data collection"
  s = s.replace(/(?<=[^\n\d])\s+(?=\d+\.\s+(?:\*\*)?[A-Za-z])/g, '\n\n');

  // Sub-bullets after a closing bold label or sentence
  s = s.replace(/:\*\*\s+(\*\s+\*\*)/g, ':**\n$1');
  s = s.replace(/([.!?])\s+(\*\s+\*\*)/g, '$1\n$2');
  s = s.replace(/(\S)\s+(\*\s+\*\*)/g, '$1\n$2');
  s = s.replace(/([^\n])\s+(-\s+\*\*)/g, '$1\n$2');

  return collapseBlankLines(s.trim());
}

function collapseBlankLines(s) {
  return s.replace(/\n{3,}/g, '\n\n');
}
